import { Form, Formik } from "formik";
import Button from "../UI/Button";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Callout from "../UI/Callout";
import { ModalDialogBody, ModalDialogFooter } from "../UI/ModalDialog";
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
import {
  COMPTEUR_INITIAL_VALUE,
  CompteurType,
  compteurValidationSchema,
} from "../../models/compteur";
import TextInput from "../UI/TextInput";
import Select from "../UI/Select";
import { handleAPIError } from "../../utils/index.jsx";
import { useState } from "react";

export default function CompteurForm({ onSubmit, compteur, onDelete }) {
  const initialValues = toInitialValuesFromSchema(
    compteurValidationSchema,
    compteur,
    COMPTEUR_INITIAL_VALUE,
  );
  const [error, setError] = useState("");

  async function submitHandler(values, { resetForm }) {
    setError("");
    const sanitizedValues = sanitizeValues(values);
    try {
      await onSubmit(sanitizedValues);
      resetForm();
    } catch (error) {
      setError(handleAPIError(error));
    }
  }
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={compteurValidationSchema}
      onSubmit={submitHandler}
    >
      {({ values }) => (
        <>
          <p className={"cardTitle text-center marginB20"}>
            <img
              src={`/photo_balance.png`}
              alt="Balance locataire"
              className={"center"}
            />
            {compteur ? "Modifier une entrée" : "Ajouter une entrée"}
          </p>

          <Form>
            <ModalDialogBody>
              <TextInput type={"date"} name={"date_releve"} />
              <Select name={"type"} label={"Type de compteur"} mandatory>
                <option value="">Sélectionner un type</option>
                {Object.values(CompteurType).map((item) => (
                  <option key={item.name} value={item.name}>
                    {item.description}
                  </option>
                ))}
              </Select>
              <TextInput
                type={"text"}
                name={"numero_compteur"}
                label={"Numéro de compteur"}
              />
              <TextInput
                type={"number"}
                name={"valeur"}
                step={"0.01"}
                label={"Index"}
                unit={CompteurType.fromName(values.type)?.unite}
                mandatory
              />
              <Callout variant="danger">{error}</Callout>
            </ModalDialogBody>
            <ModalDialogFooter>
              {onDelete && (
                <Button
                  type={"button"}
                  variant="secondary"
                  onClick={async () => {
                    if (
                      window.confirm(
                        "Voulez-vous vraiment supprimer cette entrée ?",
                      )
                    ) {
                      try {
                        await onDelete();
                      } catch (error) {
                        console.error(error);
                      }
                    }
                  }}
                >
                  Supprimer
                </Button>
              )}
              <FormikSubmitButton>Valider</FormikSubmitButton>
            </ModalDialogFooter>
          </Form>
        </>
      )}
    </Formik>
  );
}
